import { queryOptions } from '@tanstack/react-query';

import { SnakeIdObj } from '@synapex/tools/typescript';

import * as ApiClient from '../api-client';

export const siteLinkMany = ({ site_id }: SnakeIdObj<'site'>) => {
  const { queryKey, queryFn } = queryOptions({
    queryKey: ['site', site_id],
    queryFn: () =>
      ApiClient.siteLinkMany({
        site_id,
      }),
  });

  return {
    queryKey,
    queryFn,
  };
};

export const channelLinkMany = ({ channel_id }: SnakeIdObj<'channel'>) => {
  const { queryKey, queryFn } = queryOptions({
    queryKey: ['channel', channel_id],
    queryFn: () =>
      ApiClient.channelLinkMany({
        channel_id,
      }),
  });

  return {
    queryKey,
    queryFn,
  };
};
